import React from "react";
import { inject } from "mobx-react";
import OperatoryOrderPopup from "Popups/OperatoryOrderPopup";
import { SITE101_RATES_MOBILE, SITE101_SIM_KARTY } from "Constants/OrderTypes";
import { MobileConnectButton } from "ComponentsUI/Buttons";
import TariffOrderPopup from "Popups/TariffOrderPopup";
import { SITE101_NOMERA } from "Constants/OrderTypes";

const ESIM_TAG_TRANSLIT = "esim";

const RatesmobileConnectButton = (props) => {
	let {
		tariff,
		actions,
		simCards,
		antifilter,
		ApplicationModel,
		ApplicationModel: {
			text,
			siteConfig: {
				settings: { frame_esim_mts: frameEsimMtsSettings = 0 },
			},
		},
		onClickHandler,
	} = props;

	let windowSizeModelXS = props.ApplicationModel.windowSizeModel.windowSizes.xs;

	let providerGlobalId = tariff?.provider?.global?.id;
	let cbo = tariff?.provider?.operator_settings?.tariffs?.value;
	let cbou = tariff?.provider?.operator_settings?.tariffs?.url;
	let cbt = tariff?.provider?.operator_settings?.tariffs?.button_text;

	if (tariff?.utm_url) {
		if (cbo !== "popup") {
			cbo = "url";
		}
		cbou = tariff?.utm_url;
	}

	const haveEsim =
		tariff?.mobile_new?.tag_mobil?.some(({ translit }) => translit === ESIM_TAG_TRANSLIT) || false;

	let buttons;

	let frame = frameEsimMtsSettings && haveEsim && providerGlobalId === 1877;
	let buttonFrame = (
		<MobileConnectButton
			textInDB={cbt}
			texts={text}
			antifilter={antifilter}
			onClick={() => onClickHandler(providerGlobalId, actions)}
			url_name={tariff.provider.url_name}
		/>
	);

	if (frame && cbo !== "popup") {
		buttons = buttonFrame;
	} else {
		switch (cbo) {
			case "popup":
				if (cbou) {
					buttons = (
						<TariffOrderPopup
							tariff={tariff}
							modalModel={props.ApplicationModel.modalModel}
							sendingStore={props.ApplicationModel.sendingStore}
							orderType={SITE101_NOMERA}
							text={text}
							ApplicationModel={props.ApplicationModel}
							providerInfo={props.providerInfo}
							connectURL={cbou}
							buttonFrame={buttonFrame}
							frame={frame}
							onClick={() => onClickHandler(providerGlobalId, actions)}
						>
							<MobileConnectButton
								textInDB={cbt}
								texts={text}
								antifilter={antifilter}
								url_name={tariff.provider.url_name}
							/>
						</TariffOrderPopup>
					);
				}
				break;

			case "adviser":
				buttons = (
					<OperatoryOrderPopup
						antifilter={antifilter}
						xs={windowSizeModelXS}
						tariff={tariff}
						modalModel={ApplicationModel.modalModel}
						sendingStore={ApplicationModel.sendingStore}
						orderType={simCards ? SITE101_SIM_KARTY : SITE101_RATES_MOBILE}
						text={text}
						ApplicationModel={ApplicationModel}
					>
						<MobileConnectButton
							textInDB={cbt}
							texts={text}
							antifilter={antifilter}
							onClick={() => onClickHandler(providerGlobalId, actions)}
							url_name={tariff.provider.url_name}
						/>
					</OperatoryOrderPopup>
				);
				break;
			case "api":
				buttons = (
					<OperatoryOrderPopup
						antifilter={antifilter}
						xs={windowSizeModelXS}
						tariff={tariff}
						modalModel={ApplicationModel.modalModel}
						sendingStore={ApplicationModel.sendingStore}
						orderType={simCards ? SITE101_SIM_KARTY : SITE101_RATES_MOBILE}
						text={text}
						ApplicationModel={ApplicationModel}
						apiOnly={true}
					>
						<MobileConnectButton
							textInDB={cbt}
							texts={text}
							antifilter={antifilter}
							onClick={() => onClickHandler(providerGlobalId, actions)}
							url_name={tariff.provider.url_name}
						/>
					</OperatoryOrderPopup>
				);
				break;
			case "url":
				if (cbou) {
					buttons = (
						<MobileConnectButton
							textInDB={cbt}
							texts={text}
							connectURL={cbou}
							alt_text={true}
							antifilter={antifilter}
							onClick={() => onClickHandler(providerGlobalId, actions)}
							url_name={tariff.provider.url_name}
						/>
					);
				}
				break;
			case "disabled":
				buttons = (
					<MobileConnectButton
						textInDB={cbt}
						texts={text}
						defaultCursor={true}
						antifilter={antifilter}
						onClick={() => onClickHandler(providerGlobalId, actions)}
						url_name={tariff.provider.url_name}
					/>
				);
				break;
			default:
				buttons = (
					<MobileConnectButton
						textInDB={cbt}
						texts={text}
						defaultCursor={true}
						antifilter={antifilter}
						onClick={() => onClickHandler(providerGlobalId, actions)}
						url_name={tariff.provider.url_name}
					/>
				);
		}
	}

	return buttons;
};

export default inject("ApplicationModel")(RatesmobileConnectButton);
